// @flow
import React from 'react';
import { BasicButton } from '@presentational/buttons/BasicButton';
import {
  getConfiguredMetricRowsFromFormikValues,
  getIfAnyRowIsBeingEditedAnyWhereInAnyMetric,
  getMetricLabelFromMetricName,
  getNewDimensionsRowWithDefaults,
} from '@streaming-projects/user-commit-details/committed-capacity/utils';
import { If } from '@presentational/If';
import { useFormikContext } from 'formik';

export const SPCommittedCapacityAddMetricRowContainer = ({ metricRow, dimensionsArrayHelpers }) => {
  const { values: formikValues } = useFormikContext();
  const configuredMetrics = getConfiguredMetricRowsFromFormikValues(formikValues);
  const shouldAddMetricBeDisabled = getIfAnyRowIsBeingEditedAnyWhereInAnyMetric(configuredMetrics);
  const metricName = metricRow.metricName;

  return (
    <If test={metricName != null}>
      <BasicButton
        color="blue"
        disabled={shouldAddMetricBeDisabled}
        onClick={() => {
          const newRow = getNewDimensionsRowWithDefaults(metricName);
          return dimensionsArrayHelpers.push(newRow);
        }}
        text={`+ Add ${getMetricLabelFromMetricName(metricName)}`}
      />
    </If>
  );
};
